<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 17 18"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect :fill="fill" height="2" rx="1" width="17" y="2"/>
    <rect :fill="fill" height="2" rx="1" width="17" y="8"/>
    <rect :fill="fill" height="2" rx="1" transform="rotate(90 13 0)" width="6" x="13"/>
    <rect :fill="fill" height="2" rx="1" transform="rotate(90 4 6)" width="6" x="4" y="6"/>
    <rect :fill="fill" height="2" rx="1" transform="rotate(90 13 12)" width="6" x="13" y="12"/>
    <rect :fill="fill" height="2" rx="1" width="17" y="14"/>
  </svg>
</template>

<script>

export default {
  name: 'Filter2',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
